export const resolveNafLabel = (
  naf25Code: string | null | undefined,
  fallbackCode: string | null | undefined,
  designationByCode: ReadonlyMap<string, string>,
): string | undefined => {
  if (naf25Code) {
    const designation = designationByCode.get(naf25Code);

    if (designation) {
      return `${naf25Code} - ${designation}`;
    }
  }

  if (fallbackCode) {
    const designation = designationByCode.get(fallbackCode);

    if (designation) {
      return `${fallbackCode} - ${designation}`;
    }
  }

  return fallbackCode ?? undefined;
};
